module.exports = __webpack_public_path__ + "static/media/hero.21961a6b.png";